;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="be9d99ee-c799-4fc7-9afe-adf331b1620c",e._sentryDebugIdIdentifier="sentry-dbid-be9d99ee-c799-4fc7-9afe-adf331b1620c")}catch(e){}}();import classNames from '../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import React__default, { useRef, useLayoutEffect } from 'react';
import 'react/jsx-runtime';
import ArrowAngleLeft from '../../node_modules/.pnpm/@zooplus_icons@2.3.0_react-dom@18.3.1_react@18.3.1/node_modules/@zooplus/icons/dist/es/components/ArrowAngleLeft.js';
import Cross from '../../node_modules/.pnpm/@zooplus_icons@2.3.0_react-dom@18.3.1_react@18.3.1/node_modules/@zooplus/icons/dist/es/components/Cross.js';
import styles from './BurgerNavigation.module.scss.js';
import { ROOT_PATH } from './BurgerNavigationConverter.js';
import '../../_virtual/_sentry-release-injection-file.js';

const BurgerHeader = ({ currentPanel, onClickPrevPanel, translations, onCloseClick, isOpen, }) => {
    const allCategoriesTitle = translations.get('shop.header.burger.navigation.all.products') ?? '';
    const { currentPath, currentTitle = allCategoriesTitle } = currentPanel;
    const showPrevButton = currentPath !== ROOT_PATH;
    const prevLabel = translations.get('general.button.previous');
    const closeLabel = translations.get('general.button.close');
    const backBtnRef = useRef(null);
    const closeBtnRef = useRef(null);
    const handleFocusFlow = () => {
        if (backBtnRef.current && !backBtnRef.current.disabled) {
            backBtnRef.current.focus();
        }
        else if (closeBtnRef.current && !closeBtnRef.current.disabled) {
            closeBtnRef.current.focus();
        }
    };
    useLayoutEffect(() => {
        isOpen && handleFocusFlow();
    }, [currentPanel, isOpen]);
    return (React__default.createElement("header", { className: styles.burgerHeaderWrapper },
        React__default.createElement("button", { ref: backBtnRef, className: classNames(styles.burgerHeaderPrevPanelBtn, {
                [styles.burgerHeaderPrevPanelBtnHidden]: !showPrevButton,
            }), "data-zta": "burger-header-prev-btn", type: "button", "aria-label": prevLabel, disabled: !showPrevButton, onClick: () => onClickPrevPanel(currentPath) },
            React__default.createElement(ArrowAngleLeft, { "aria-label": prevLabel, "data-zta": "burger-prev-icon", className: styles.burgerPrevButton })),
        React__default.createElement("p", { "data-zta": "burger-header-main-link", className: styles.burgerHeaderMainLink }, currentTitle),
        React__default.createElement("button", { ref: closeBtnRef, className: styles.burgerHeaderCloseBtn, "data-zta": "burger-header-close-btn", type: "button", "aria-label": closeLabel, onClick: onCloseClick },
            React__default.createElement(Cross, { "aria-label": closeLabel, "data-zta": "burger-close-icon", className: styles.burgerCloseButton }))));
};

export { BurgerHeader as default };
//# sourceMappingURL=BurgerHeader.js.map
